//Common analytics store module. app/analytics
import apiConstructor from '../../api/constructor'
import { omit } from 'lodash'

/**
 * Check folder
 *
 * @param {Object} item
 * @param {Array} modules
 * @return {Boolean}
 */
function checkTreeItem(item, modules) {
  if (!modules) {
    return true
  }
  if (!Array.isArray(modules)) {
    modules = [modules]
  }
  if (modules.length === 0) {
    return true
  }
  const access = item.modules || {}
  for (const module of modules) {
    if (access.hasOwnProperty(module)) {
      return true
    }
  }
  return false
}

/**
 * Filter tree
 *
 * @param {Array} items
 * @param {Array} modules
 * @param {Boolean} available
 * @returns {Array}
 */
function filter(items, modules, available = false) {
  let result = []
  for (const item of items) {
    const hasAccess = checkTreeItem(item, modules)

    // Check if property
    if (item.element_type === 'property') {
      if (hasAccess) {
        result.push(item)
      }
      continue
    }

    // Check access
    if (hasAccess) {
      // Доступна вся ветка
      const children = item.children || []
      if (children.length === 0) {
        // Hide empty folders
        // @todo Проверить поведение, возможно показывать пустые папки
        continue
      }
      result.push(item)
    } else {
      const children = filter(item.children || [], modules)
      for (const childItem of children) {
        result.push(childItem)
      }
    }
  }
  return result
}
/**
 * State data
 */
const state = {
  tree: null
}
/**
 * State getters
 */
const getters = {
  tree(state) {
    return state.tree || []
  },
  properties(state, getters) {
    let properties = []
    let nodes = getters.tree.map(it => it)
    while (nodes.length > 0) {
      let node = nodes.pop()
      if (node.element_type === 'property') {
        properties.push(node)
      }
      const children = node.children || []
      for (let i = 0; i < children.length; i++) {
        nodes.push(children[i])
      }
    }
    return properties
  },
  propertiesHash(_, getters) {
    const properties = getters.properties
    let result = {}
    for (let i = 0; i < properties.length; i++) {
      let p = properties[i]
      result[p.id] = p
    }
    return result
  },
  getModulesTree(_, getters) {
    return function(modules = []) {
      return filter(getters.tree, modules, false)
    }
  }
}
/**
 * State actions
 */
const actions = {
  // Load properties tree
  loadPropertiesTree({ state, commit }, force = false) {
    if (state.tree === null || force === true) {
      return apiConstructor.getProperties().then(response => {
        commit('SET_TREE', response.all)
        return response.all
      })
    }
    return Promise.resolve(state.tree)
  }
}
/**
 * State mutations
 */
const mutations = {
  // Сброс при смене компании
  RESET(state) {
    state.tree = null
  },
  SET_TREE(state, treeData) {
    state.tree = treeData
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/apps/analytics/store/common/index.js